import { render, staticRenderFns } from "./TagBlock.vue?vue&type=template&id=2a330e2f&scoped=true"
import script from "./TagBlock.vue?vue&type=script&lang=js"
export * from "./TagBlock.vue?vue&type=script&lang=js"
import style0 from "./TagBlock.vue?vue&type=style&index=0&id=2a330e2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a330e2f",
  null
  
)

export default component.exports